import { createFileRoute } from "@tanstack/react-router";

import ChallengeDetailsForm from "@/components/ChallengeProfile/ChallengeDetailsForm";

const Component = () => {
  const { challengeUuid } = Route.useParams();
  return <ChallengeDetailsForm challengeUuid={challengeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/profile/details")({
  component: Component,
});
